import { DataState } from '@/types/data.type';

// NOTE: Sets the same data state for each key, e.g. reel codes
export function buildDataStateMap(
    keys: string[],
    dataState: DataState,
): Record<string, DataState> {
    return Object.fromEntries(keys.map((key) => [key, dataState]));
}
